import { render, staticRenderFns } from "./StarDetail.vue?vue&type=template&id=9ffc8bb6&scoped=true&"
import script from "./StarDetail.vue?vue&type=script&lang=js&"
export * from "./StarDetail.vue?vue&type=script&lang=js&"
import style0 from "./StarDetail.vue?vue&type=style&index=0&id=9ffc8bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffc8bb6",
  null
  
)

export default component.exports